export default __webpack_public_path__ + "static/media/rt_layout_reset.58a32430.svg";